var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('table-list',{staticClass:"mt12",attrs:{"columns":_vm.columns,"data":_vm.data,"current":_vm.current,"total":_vm.total,"loading":_vm.loading},on:{"change-page":_vm.changPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }